import { render, staticRenderFns } from "./OtherSkills.vue?vue&type=template&id=603dcd68&"
import script from "./OtherSkills.vue?vue&type=script&lang=js&"
export * from "./OtherSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports